import { Input, MultiSearchForm, useDebouncedSearch } from "@";
import { searchValues } from "../lib/options";

const MultiSearch = ({
  search,
  onSubmit,
  updateSearch,
  affiliateUsers,
  onReset,
}) => {
  useDebouncedSearch(onSubmit, search.values, searchValues);

  const usersOptions = affiliateUsers?.map((option) => ({
    value: option.id,
    label: option.name,
  }));

  const handleInputChange = (field, value) => {
    updateSearch({
      values: { ...search.values, [field]: value },
    });
  };

  const handleReset = () => {
    if (onReset) {
      onReset();
    } else {
      updateSearch({ values: searchValues });
    }
  };

  return (
    <MultiSearchForm
      show={search.show}
      onSubmit={onSubmit}
      className="multi-search-form xl:grid-cols-5"
      reset={handleReset}
    >
      <>
        {/* Input for keyword search */}
        <Input
          star
          label="كلمة البحث"
          value={search.values.keyword}
          change={(e) => handleInputChange("keyword", e.target.value)}
        />

        {/* Input for selecting affiliate user */}
        <Input
          star
          label="المنسقين"
          type="select-searchable"
          list={usersOptions}
          value={usersOptions?.filter((c) => search.values.user == c.value)}
          change={(e) => handleInputChange("user", e ? e.value : null)}
        />

        {/* Input for selecting date */}
        <Input
          style="xl:col-span-2"
          star
          showTimeSelect
          type="date-range"
          labelA="من تاريخ"
          labelB="الي تاريخ"
          valueB={search.values.toDate}
          valueA={search.values.fromDate}
          changeA={(e) => handleInputChange("fromDate", e)}
          changeB={(e) => handleInputChange("toDate", e)}
        />
      </>
    </MultiSearchForm>
  );
};

export default MultiSearch;
